export { SerpOffersModule } from './SerpOffers';
